import React, { Component} from 'react';
import Slidebar from './components/slidebar';
import './init';

  class App extends Component {
    render() {
      return (
        <div className="App">
        
        <Slidebar/>
        
        <canvas id='renderCanvas'></canvas>
        
        </div>
      );
    }
  }

  export default App;